import { BiTransfer } from "react-icons/bi";
import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary

function VGM() {
  return (
    <>
<div className="service-title font-700 mb-3">VGM
  <span className="text-orange-ef3e33 font-400 text-uppercase"> Verified Gross Mass of containers </span></div>

<div className="row g-3 g-sm-4 g-md-5">
   
    <div className="col-12">
        <p className="font-18 mb-4">
          IMO’s amendments to the Safety of Life at Sea Convention (SOLAS) Regulation VI/2 was prompted by the need to curb the mis-declaration of container weight which had resulted in numerous casualties. Container weight mis-declaration has the potential to cause injury and loss of life for the crew as well as port workers and causing damage to property which includes the vessel and shore machinery such as cranes.
        </p>
          <p className="font-18 mb-4">
          Together with the amendment to the Regulation VI/2, the International Maritime Organization (IMO) introduced “Guidelines Regarding the Verified Gross Mass of a Container Carrying Cargo” (MSC.1/Circ.1475) dated 9 June 2014, to establish a common approach for the implementation and enforcement of the SOLAS requirements regarding the verification of the gross mass of packed containers. The Guideline provide recommendations on how to interpret and apply the provisions of the SOLAS requirements. The SOLAS Verified Gross Mass (VGM) regulations came into effect on July 1, 2016. The applicable South African legislation is the Merchant Shipping (Carriage of Cargoes) Regulations, 2004.
        </p>

        {/* <ul className="trust">
            <li>Vessel inspections to ensure that the workplace, equipment and worker behavior is healthy and safe</li>
            <li>Legal compliance audits against the Maritime Occupational Safety Regulations, 1994 and other applicable legislation and codes.</li>
            <li>Stakeholder engagement through the various stevedore and ship repair safety committees that have been established as a platform for stakeholders in both industries to raise issues with respect to health and safety.  </li>
        </ul>

         */}
        <ul className="trust">
           
            <li>
               The main principles of the IMO guideline are as follows:
                <ul className="star-li">
                    <li>The shipper is responsible for obtaining and providing the VGM of a packed container; and</li>
                    <li>A container partially or fully packed should not be loaded onto a ship to which the SOLAS Convention applies unless the Master or his representative and the terminal representative have obtained, in advance of a vessel loading, the actual VGM of the container.</li>
                    
                </ul>

            </li>
              <li>
               The SOLAS regulations prescribe two methods by which the Shipper may obtain the verified gross mass of a packed container:
                <ul className="star-li">
                    <li><b>Method No.1:</b> Upon the conclusion of packing and sealing a container, the shipper may weigh, or have arranged that a third-party weigh,   
                      the packed container.</li>
                     <li><b>Method No.2:</b> The Shipper (or, by arrangement of the shipper, a third party), may weigh all packages and cargo items, including the mass       
                      of pallets, dunnage and other packing and securing material to be packed in the container, and add the tare mass of the   
                      container to the sum of the single masses using a certified method.
                     </li>
                </ul>

            </li>
            <li>The IMO Guideline states that method used for weighing the container's contents under Method No.2 is subject to certification and approval as determined by the competent authority of the State in which the packing and sealing of the container was completed. SAMSA has been approving shippers for Method 2 since July 2016.</li>
            <li>SAMSA having considered the need for ensuring consistent application of the verified gross mass for containers, will authorize or recognise weighing facilities (also commonly referred to as weighbridges), lifting equipment such as reach stackers equipped with a weighing device, mobile weighing equipment such as load cell jacks for declaring the VGM using Method No. 1 for shipper’s who do not intend to use Method No. 2. This will result in SAMSA’s being responsible for certifying and approving the method used for obtaining the VGM under both Method 1 and 2.</li>
           <li>SAMSA also recognises packing facilities that is contracted to more then 3 shippers or by voluntary application for packing facilities contracted to at least one shipper. The ultimate responsibility to declare VGM remains with the shipper even though the actual weighing, packing and securing is subcontracted to a packing facility.</li>
           <li>
            For more detailed information on the VGM compliance regime in South Africa see the latest VGM Guidelines/Marine Notice……..
           </li>
           <li>
            For any enquiries write to <a href="mailto:vgm@samsa.org.za">vgm@samsa.org.za </a> 
           </li>



            <li>
               List of SAMSA accredited VGM Entities and Authorised Shippers
               <ul className="star-li">
                    <li>A list of valid SAMSA accredited VGM entities that are approved to Authorised Shippers can be found in the following link:<p>
                      </p></li>
                    <li>A list of Recognised Weighing Facilities approved to obtain the VGM using Method No. 1 can be found in the following link
                      <p>List of Weighing Facilities list under development</p>
                    </li>
                    <li>A list of Authorised Shippers approved to use VGM Method No. 2 can be found in the following link
                      <p>List of Authorised Shippers list under development</p>
                    </li>
                    <li>A list of Recognised Packing Facilities approved to use VGM Method No. 2 for specific Shippers:
                      <p>List of Recognised Packing Facilities list under development</p>
                    </li>
                </ul>

            </li>
                 {/* <li>
                  Drafting Marine Notices to bring the following to the attention of industry:
                <ul className="star-li">
                    <li>High risk activities or activities that have resulted in the injury to workers</li>
                    <li>Interpretation of legislation</li>
                </ul>

            </li>
               */}

            

            {/* <li>
                Conducting roadshows on a regular basis to:
                <ul className="star-li">
                    <li>Introduce the South African Maritime Safety Authority and its mandate</li>
                    <li> Inform industry of legislative requirements e.g. accident / casualty reporting</li>
                    <li>Communicate the findings of research projects undertaken by the Authority e.g. </li>
                <ul className="star-li">
                    <li>University of KwaZulu Natal:  The Health of Stevedore Ship Repairmen</li>
                    <li>Life Occupational Health:  Health Risk Assessment to determine the medical assessment criteria Occupational Health Practitioners should use to certify workers fit for duty</li>
                </ul>
                <li>Arranging experts to present on high risk activities such Noise Induced Hearing Loss, Working at Heights, PPE Requirements, Medical Surveillance Findings.</li>
                </ul>

            </li>
              <li>
                 Establishment of projects to create safety awareness:
                <ul className="star-li">
                    <li>Stevedore and Ship Repair Safety Films which are translated into English, Zulu, Afrikaans and Xhosa.</li>
                    <li>Stevedore and Ship Repair Safety Posters</li>
                </ul>

            </li>
              <li>
                  For guidance on Maritime Occupational Health and Safety, please see related information links or contact Mr. Sibusiso Rant​soabe on 031 307 3006.
              
            </li> */}
        </ul>

    </div>
    
</div>
    </>
  );
}


export default VGM